// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3BV-W","inputDescription":"styles_inputDescription__12mar"};